// extracted by mini-css-extract-plugin
module.exports = {"menu":"ActionsDropdown_menu__w7hqI","menuItem":"ActionsDropdown_menuItem__11T-C"};